import { combineReducers } from 'redux'
import app from './app'
import user from './user'
import modules from './modules'
import module from './module'
import comments from './comments'
import comment from './comment'
import simulation from '../simulation/reducers';
import notifications from "./notifications";

export default combineReducers({
  app,
  user,
  modules,
  module,
  notifications,
  comments,
  comment,
  simulation,
})
